export default "__VITE_ASSET__Bn59VbIj__"